import { TranslationKeys } from "../types";
import { SITE_CONFIG } from "../../app/config";

export const de: TranslationKeys = {
  hero: {
    title1: "BESITZE DEINEN",
    title2: "SOUND",
    streamingRenting: "STREAMING",
    vinylCdForever: "VINYL & CD",
    description: `Spotify-Playlist rein. Einkaufsliste raus. Mach Musik zu deinem Eigentum. Bau dir eine echte Sammlung auf.`,
    ctaName: SITE_CONFIG.name,
  },
  
  perks: {
    ownIt: {
      title: "Echt Deins",
      desc: "Kein Abo. Nichts verschwindet. Einmal zahlen, für immer deins. Echtes Eigentum.",
    },
    quality: {
      title: "Physisch kickt anders",
      desc: "Analoge Wärme oder digitale Perfektion. Streaming kann da einfach nicht mithalten.",
    },
    collection: {
      title: "Flex deine Sammlung",
      desc: "Regal-Goals. Wandkunst. Gesprächsstoff. Eine echte Sammlung zum Angeben.",
    },
  },
  
  form: {
    placeholder: "https://open.spotify.com/playlist/37i9dQZF1DXcBWIGoYBM5M",
    go: "LOS",
    tryExample: "Keine Playlist? Probier ein Beispiel",
    errors: {
      emptyPlaylist: "Spotify-Playlist-URL oder ID einfügen um loszulegen.",
      cloudflareCheck: "Cloudflare-Check abschließen.",
      cloudflareValidation: "Cloudflare-Validierung fehlgeschlagen. Nochmal versuchen.",
    },
  },
  
  results: {
    scanning: "PLAYLIST WIRD GESCANNT",
    yourHaul: "DEINE VINYL & CD BEUTE",
    playlist: "Playlist",
    tracksToAlbums: "Tracks → Alben zum Besitzen",
    track: "Track",
    tracks: "Tracks",
    oops: "HOPPLA!",
    unableToProcess: "Playlist konnte nicht verarbeitet werden.",
    noAlbumsFound: "KEINE ALBEN GEFUNDEN",
    noAlbumsDesc: "Nichts gefunden für diese Playlist!",
    tryDifferent: "Probier's mit einer anderen Playlist mit mehr Tracks.",
    albumsToOwn: "ALBEN ZUM BESITZEN",
    comingSoon: "Bald verfügbar",
    ownIt: "BESITZ ES →",
  },
  
  share: {
    shareHaul: "🔥 BEUTE TEILEN",
    linkCopied: "🔗 LINK KOPIERT!",
    shared: "🚀 GETEILT!",
    shareText: `🔥 Ich starte meine Vinyl & CD Sammlung! Check meine Ausbeute für "{playlistName}" 💿🎵 #vinylcollection #cdcollection #ownthemusic`,
  },
  
  affiliate: {
    disclosure: "Affiliate-Info:",
    disclosureText: `${SITE_CONFIG.name} ist Teil des ${SITE_CONFIG.affiliatePartner} Partnerprogramms. Wir verdienen an qualifizierten Käufen über unsere Links, ohne Extrakosten für dich. Das hält ${SITE_CONFIG.name} am Laufen!`,
    notice: `Info: Links unten sind Affiliate-Links. Wir verdienen eventuell mit, ohne dass es dich mehr kostet. Danke für den Support von ${SITE_CONFIG.name}!`,
  },
  
  faq: {
    title: "Häufige Fragen",
    subtitle: "ALLES ÜBER DAS BESITZEN DEINER MUSIK.",
    sponsored: "Gesponsert",
    adTitle: "Mehr Musik-Gear entdecken",
    adDesc: "Premium Plattenspieler, CD-Hüllen & mehr",
    items: [
      {
        question: `Wie funktioniert ${SITE_CONFIG.name}?`,
        answer: "Füge eine öffentliche Spotify-Playlist-URL in GoOffline ein. Wir scannen jeden Track, finden passende physische Veröffentlichungen — Vinyl, CDs und Kassetten — und zeigen dir, wo du sie kaufen kannst, mit echten Preisen von Discogs. Ein Klick vom Streaming zum Besitzen.",
      },
      {
        question: `Ist ${SITE_CONFIG.name} kostenlos?`,
        answer: "Ja, GoOffline ist komplett kostenlos. Keine Anmeldung, kein Abo, keine versteckten Kosten. Wir verdienen eine kleine Provision, wenn du über unsere Affiliate-Links kaufst — das kostet dich nichts extra und hält das Tool am Laufen.",
      },
      {
        question: "Brauche ich ein Spotify-Konto oder Login?",
        answer: "Kein Konto und kein Login nötig. Einfach einen öffentlichen Spotify-Playlist-Link oder Share-URL einfügen. Wir greifen nie auf dein Spotify-Konto zu — wir lesen nur die Tracks der geteilten Playlist.",
      },
      {
        question: "Welche Musikformate kann ich finden — Vinyl, CD oder Kassette?",
        answer: "GoOffline sucht nach Vinyl-Schallplatten, CDs und Kassetten. Jede Albumkarte zeigt, welche Formate verfügbar sind, zusammen mit aktuellen Marktpreisen. Vinyl und CD sind am häufigsten, die Kassetten-Verfügbarkeit variiert je nach Titel.",
      },
      {
        question: "Funktioniert das mit privaten Spotify-Playlists?",
        answer: "Aktuell werden nur öffentliche Playlists unterstützt. Schneller Workaround: Stelle deine Playlist kurz auf öffentlich, scanne sie auf GoOffline und schalte sie dann wieder auf privat. Dauert etwa 10 Sekunden.",
      },
      {
        question: "Woher kommen die Preise?",
        answer: "Alle Preise stammen von Discogs, dem weltweit größten Marktplatz für Vinyl und CDs mit über 80 Millionen Angeboten. Wir zeigen geschätzte Preise basierend auf echten Marktdaten, damit du eine verlässliche Orientierung hast.",
      },
      {
        question: "Wie genau sind die Vinyl- und CD-Preise?",
        answer: "Die Preise werden aus aktuellen Discogs-Marktdaten geschätzt und spiegeln reale Marktbedingungen wider. Der tatsächliche Preis kann je nach Pressung, Zustand und Verkäufer variieren. Sieh es als verlässlichen Ausgangspunkt für die Budgetplanung deiner Sammlung.",
      },
      {
        question: "Kann ich meine Vinyl- und CD-Einkaufsliste teilen?",
        answer: "Ja! Klick auf den Teilen-Button, um deine Beute an Freunde zu schicken oder in Social Media zu posten. Jedes Ergebnis bekommt einen einzigartigen teilbaren Link. Teilen hilft uns, kostenlos zu bleiben, und hilft deinen Freunden, physische Musik zu entdecken.",
      },
      {
        question: "Was wenn ein Album nicht gefunden wird?",
        answer: "GoOffline funktioniert am besten mit bekannten Veröffentlichungen — Classic Rock, Jazz, Hip-Hop, Pop-Hits und Legacy-Kataloge haben die höchsten Trefferquoten. Neuere Indie- oder rein digitale Releases haben möglicherweise noch keine physischen Pressungen. Je ikonischer das Album, desto besser die Ergebnisse.",
      },
      {
        question: "Warum 2026 noch Vinyl oder CDs kaufen?",
        answer: "Vinyl-Verkäufe sind 18 Jahre in Folge gewachsen und haben Rekordhöhen erreicht. CDs erleben ebenfalls ein Comeback und bieten verlustfreie Audioqualität zu günstigen Preisen. Physische Musik bedeutet echtes Eigentum — keine Abos, keine verschwindenden Kataloge und echte Regalpräsenz.",
      },
      {
        question: "Vinyl vs CD — welches Format soll ich kaufen?",
        answer: "Vinyl bietet warmen analogen Sound, Sammlerwert, große 12-Zoll-Artworks und ist ein tolles Schaustück. CDs sind günstiger, portabler, liefern perfekte digitale Audioqualität und sind leichter zu finden. Beides ist besser, als monatlich Musik zu mieten, die von Streaming-Plattformen verschwinden kann.",
      },
      {
        question: `Gehört ${SITE_CONFIG.name} zu Spotify?`,
        answer: "Nein. GoOffline ist ein unabhängiges Tool für Musikfans, die ihre Sammlung besitzen wollen. Wir nutzen die öffentliche Spotify API, um Playlist-Daten zu lesen, sind aber in keiner Weise von Spotify unterstützt oder mit Spotify verbunden.",
      },
      {
        question: `Sind meine Daten bei ${SITE_CONFIG.name} privat und sicher?`,
        answer: "Absolut. Wir benötigen kein Login und keine persönlichen Daten. Wir lesen nur die Track-Daten der öffentlichen Playlist-URL, die du angibst. Keine Tracking-Cookies, kein Datenverkauf. Deine Privatsphäre wird vollständig respektiert.",
      },
      {
        question: "Warum physische Musik statt Streaming besitzen?",
        answer: "Streaming-Dienste können Alben ohne Vorwarnung entfernen, wenn Lizenzen auslaufen. Physische Musik gehört dir für immer — keine Algorithmen, die bestimmen was du hörst, keine Abo-Müdigkeit, keine Konzernentscheidungen über deine Bibliothek. Und nichts geht über das Ritual, eine Nadel auf Vinyl aufzusetzen oder Album-Artwork in den Händen zu halten.",
      },
    ],
  },
  
  footer: {
    affiliateDisclosure: "Affiliate-Info:",
    copyright: `© ${new Date().getFullYear()} ${SITE_CONFIG.name} — Spotify zu Vinyl & CD Converter`,
    converter: "Spotify zu Vinyl & CD Converter",
    terms: "AGB",
    privacy: "Datenschutz",
    affiliateLink: "Affiliate-Info",
    notAffiliated: "Nicht mit Spotify verbunden",
  },
  
  ad: {
    label: "ANZEIGE",
    title: "Deine Anzeige Hier",
    desc: "Responsive Display Ad · 728×90 oder ähnlich",
  },
  
  language: {
    label: "Sprache",
    en: "English",
    fr: "Français",
    de: "Deutsch",
    pl: "Polski",
  },
};
